export const certificationsData = {
    "id": "69348864-c815-4a18-b086-ff9ac847813c",
    "isActive": true,
    "createdAt": "2025-12-03T16:44:24.546Z",
    "updatedAt": "2025-12-03T16:44:24.546Z",
    "attemptDate": "2025-12-03T16:44:24.546Z",
    "certificationScore": "0.00",
    "sessionId": "sess_CikFTMtPbLSPDZfFy6NOY",
    "certificationReview": null,
    "user": {
        "id": "84c8e468-6041-7012-ce94-82caae7317d3",
        "isActive": true,
        "createdAt": "2025-04-30T17:17:18.582Z",
        "updatedAt": "2025-11-19T19:19:07.704Z",
        "firstName": "Amit",
        "lastName": "Patel",
        "email": "amit@praxispro.ai",
        "password": null,
        "isEmailVerified": true,
        "userType": "R",
        "role": "ACCOUNT_SPECIALIST",
        "profileImg": null,
        "lastActive": null,
        "otp": null,
        "otpDate": null,
        "regionId": null,
        "productId": null,
        "wentTroughQuestionnaire": true,
        "wentTrhoughTutorialCount": 1,
        "group": "psychiatry-neurology"
    },
    "certificationAssignment": {
        "id": "850f6834-3f46-4197-b0ba-46d7c6c52765",
        "isActive": true,
        "createdAt": "2025-12-03T15:54:27.666Z",
        "updatedAt": "2025-12-03T15:54:27.666Z",
        "userId": "84c8e468-6041-7012-ce94-82caae7317d3",
        "certificationId": "225723d8-6aca-4565-96b1-1a7d7feeef05",
        "dueDate": "2025-12-10T18:30:00.000Z",
        "attemptCount": 1,
        "finalScore": "0.00",
        "finalStatus": "IN_PROGRESS",
        "certification": {
            "id": "225723d8-6aca-4565-96b1-1a7d7feeef05",
            "isActive": true,
            "createdAt": "2025-12-03T15:54:27.272Z",
            "updatedAt": "2025-12-03T15:54:27.272Z",
            "certificationName": "New Hire 144",
            "certificationStartDate": "2025-12-01T18:30:00.000Z",
            "certificationAttemptsAllowed": 1,
            "certificationDueDate": "2025-12-10T18:30:00.000Z",
            "autoAssign": true,
            "isLocationBased": false,
            "isProductBased": false,
            "createdBy": "54887448-e001-70b6-53ca-53a7dad2c2e9",
            "practitionerType": "MDS (Minimum Data Set) Coordinator",
            "objectionLevel": "M",
            "personalityType": [
                "the-empathetic-caregiver"
            ]
        }
    },
    "report": {
        "id": "bc006973-2e36-4dcc-8dcd-eb95a2fe2ea0",
        "sessionId": "sess_CikFTMtPbLSPDZfFy6NOY",
        "data": {
            "report": {
                "summary": "<ul><li>No sales representative statements were provided in the conversation, so there is no basis for evaluating product knowledge, compliance, brand alignment, or communication skills.</li><li>To receive actionable feedback, please ensure the sales representative participates in the conversation and provides responses related to Ingrezza or other relevant topics.</li></ul>",
                "constant_metrics": {
                    "tone": {
                        "value": 0,
                        "feedback": ""
                    },
                    "score": {
                        "value": 0,
                        "feedback": ""
                    },
                    "filler": {
                        "value": 0,
                        "feedback": ""
                    },
                    "sentiment": {
                        "value": 0,
                        "feedback": ""
                    },
                    "vocabulary": {
                        "value": 0,
                        "feedback": ""
                    },
                    "languageClarity": {
                        "value": 0,
                        "feedback": ""
                    },
                    "speakListenRatio": {
                        "value": 0,
                        "feedback": ""
                    }
                },
                "variable_metrics": {
                    "brandStrategy": {
                        "value": 0,
                        "feedback": ""
                    },
                    "productKnowledge": {
                        "value": 0,
                        "feedback": ""
                    },
                    "questionTechniques": {
                        "value": 0,
                        "feedback": ""
                    },
                    "compliancePercentage": {
                        "value": 0,
                        "feedback": ""
                    }
                }
            },
            "duration": 10.607737,
            "conversations": [
                {
                    "content": "Hey, thanks for coming in. Let's hear what you've got.",
                    "isUserMessage": false
                },
                {
                    "content": "",
                    "isUserMessage": true
                }
            ]
        },
        "createdAt": "2025-12-03T16:44:24.563Z",
        "invalidAt": null,
        "status": "completed",
        "failureReason": null,
        "playbackUrl": "https://s3.amazonaws.com/dev.ingrezza-neurocrine.assets.praxis.com/app/users/c4a8e4c8-f0b1-7062-2cc0-dfefda1485f7/calls/sess_BSSlAeqepe78qL3cwK3Gp/combined-video.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATZXUDFMLUZTPAQEC%2F20251228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20251228T130352Z&X-Amz-Expires=3600&X-Amz-Signature=4a682481847736686fb25f93c2c3d18c0ec4d35a95b70bc4c1a6b89e13acdc55&X-Amz-SignedHeaders=host"
    }
}